import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Dialog, DialogTitle, DialogContent, IconButton, CircularProgress } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import CloseIcon from "@material-ui/icons/Close";
import ErrorTryAgain from "../../shared/ErrorTryAgain/ErrorTryAgain";
import { makeStyles } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import api from "../../../store/api";

type reasonType = {
  name: string;
  reasonForWaitTimeId: string;
};

const SCREEN_TYPE = {
  REASON_SELECTION: "REASON_SELECTION",
  TIMER: "TIMER",
};

const useStyles = makeStyles({
  headerTitle: {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: 400,
  },
  closeIcon: {
    position: "absolute",
    top: "8px",
    right: "8px",
  },
  centeredContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
  },
  timerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  heading: {
    fontWeight: 900,
    fontSize: "38px",
    color: "#fff",
    marginBottom: 8,
  },
  note: {
    fontSize: "26px",
    color: "#fff",
    opacity: "0.5",
  },
  reasonsList: {
    margin: "31px 0",
    padding: 0,
  },
  reasonItem: {
    backgroundColor: "#D8D8D810",
    height: 60,
    borderRadius: 6,
    display: "flex",
    justifyContent: "space-between",
    fontSize: 30,
    color: "#fff",
    listStyle: "none",
    marginBottom: 6,
    alignItems: "center",
    padding: "0 20px",
    cursor: "pointer",
  },
  waitingHeading: {
    fontWeight: 700,
    fontSize: "38px",
    color: "#fff",
    margin: "50px 0 10px",
  },
  waitingReason: {
    fontSize: "24px",
    color: "#fff",
  },
  timer: {
    fontWeight: 900,
    fontSize: "65px",
    color: "#fff",
    margin: "105px 0 135px",
  },
  stopButton: {
    fontWeight: 700,
    fontSize: "19px",
    color: "#131415",
    borderRadius: 4,
    backgroundColor: "#fff",
    height: 55,
    width: 199,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  cancelButton: {
    marginTop: 14,
    fontWeight: 700,
    fontSize: "19px",
    color: "#fff",
    height: 55,
    width: 199,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  saveButton: {
    marginRight: "16px",
    marginTop: "19px",

    "@media (max-width: 1024px)": {
      marginTop: "0",
    },
  },
});

const theme = createMuiTheme({
  overrides: {
    MuiDialog: {
      paperFullWidth: {
        width: "100%",
        height: "100%",
        margin: 0,
        maxHeight: "100%",
        borderRadius: 0,
        backgroundColor: "#000d2a",
      },
    },
    MuiDialogTitle: {
      root: {
        color: "#fff",
      },
    },
    MuiIconButton: {
      root: {
        color: "#fff",
      },
    },
    MuiDialogContent: {
      dividers: {
        borderTop: "1px solid rgba(255, 255, 255, 0.12)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
        flex: "0 1 auto",
      },
    },
  },
});

interface WaitingTimeModalProps {
  transferId: string;
  tripId: string;
  onClose: any;
  WaitTimeTransferStatus:number;
  setWaitTimeClick:any;
  WaitTimeClick: any;
}

const secondsFormat = (seconds: number) => {
  const minutes = (seconds % 3600) / 60;
  return `${("0" + Math.round(seconds / 3600).toString()).slice(-2)}:${("0" + Math.floor(minutes).toString()).slice(-2)}:${(
    "0" + Math.floor(seconds % 60).toString()
  ).slice(-2)}`;
};

const WaitingTimeModal = ({ onClose, transferId, tripId,WaitTimeTransferStatus,setWaitTimeClick,WaitTimeClick}: WaitingTimeModalProps) => {
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [screenType, setScreenType] = useState(SCREEN_TYPE.REASON_SELECTION);
  const [reasonsList, setReasonsList] = useState<reasonType[]>([]);
  const [selectedReason, setSelectedReason] = useState<reasonType>();
  const [transferWaitTimeId, setTransferWaitTimeId] = useState<string>();
  const [timerSec, setTimerSec] = useState<number>(0);
  const [showDialog, setShowDialog] = useState(false);
  const timerRef = React.useRef<any>(null);
  const startTimerValue = React.useRef(0);

  useEffect(() => {
    const reason: reasonType = {
      reasonForWaitTimeId: localStorage.getItem("reasonForWaitTimeId") || "",
      name: localStorage.getItem("name") || ""
    };
    var transferId = localStorage.getItem("transferId");
    if(reason?.reasonForWaitTimeId!= "" && !WaitTimeClick){
      startWaitingTime(reason,transferId)
    }
   
  }, []);
  
  React.useEffect(() => {
    setIsLoading(true);
    setIsError(false);
    api.getReasonsForWaitTimeUser("").then((resp) => {
      if (resp.data !== null && resp.data.model !== null && !resp.data.errorRaised) {
        setReasonsList(resp.data.model);
      } else {
        setIsError(true);
      }
      setIsLoading(false);
    });
  }, []);

  React.useEffect(() => {
    return () => {
      if (timerRef && timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const startWaitingTime = (reason: reasonType,pram_transferId : any) => {
    setIsLoading(true);
    setIsError(false);
    setSelectedReason(reason);
    localStorage.setItem("reasonForWaitTimeId",reason.reasonForWaitTimeId)
    localStorage.setItem("name",reason.name)
    const req = {
      transferId: (transferId === null || transferId === '' || transferId === undefined) ? pram_transferId : transferId ,
      tripId: tripId,
      reasonForWaitTimeId: reason.reasonForWaitTimeId,
      waitTimeTransferStatus: WaitTimeTransferStatus,
    };
    try {
      api.startWaitTimer("", req).then(async (resp) => {
        if (resp !== null && resp.transferWaitTimeId !== null && !resp.hasError) {
          setTransferWaitTimeId(resp.transferWaitTimeId);

          if (resp.message == "Success: found an active wait time capture record") {
            const wtResp = await api.getWaitTimeDetails("", { transferWaitTimeId: resp.transferWaitTimeId });
            const waitTimeMs = wtResp.model?.waitDuration?.totalMilliseconds || 0;
            startTimerValue.current = new Date().getTime() - waitTimeMs;
          } else {
            startTimerValue.current = new Date().getTime();
          }

          // start timer UI
          timerRef.current = setInterval(() => {
            setTimerSec((new Date().getTime() - startTimerValue.current) / 1000);
          }, 1000);

          setWaitTimeClick(false);
          // set timer screen
          setScreenType(SCREEN_TYPE.TIMER);
        } else {
          setIsError(true);
        }
      });
    } catch (error) {
      setIsError(true);
    }
    setIsLoading(false);
  };

  const stopTimer = () => {
    setIsLoading(true);
    setIsError(false);
    const req = {
      transferWaitTimeId: transferWaitTimeId,
    };
    try {
      api.stopWaitTimer("", req).then((resp) => {
        if (resp !== null && !resp.hasError) {
          // close modal with trip reload
          onClose({ reload: true });
        } else {
          setIsError(true);
          setIsLoading(false);
        }
      });
      setWaitTimeClick(false);
      localStorage.removeItem("reasonForWaitTimeId");
      localStorage.removeItem("name");
      localStorage.removeItem("transferId");
      localStorage.removeItem("ShowWaitModel");
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
    }
  };

  const cancelTimer = () => {
    setIsLoading(true);
    setIsError(false);
    const req = {
      transferWaitTimeId: transferWaitTimeId,
    };
    try {
      api.cancelWaitTimer("", req).then((resp) => {
        if (resp !== null && !resp.hasError) {
          // close modal without trip reload
          onClose({ reload: false });
          setWaitTimeClick(false);
        } else {
          setIsError(true);
          setIsLoading(false);
        }
      });
      localStorage.removeItem("reasonForWaitTimeId");
      localStorage.removeItem("name");
      localStorage.removeItem("transferId");
      localStorage.removeItem("ShowWaitModel");
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
    }
  };

  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={true} onClose={onClose} fullWidth={true} maxWidth="xl" keepMounted={true}>
        <div style={screenType === SCREEN_TYPE.TIMER ? { backgroundColor: "#E05151", width: "100%", height: "100%" } : {}}>
          {(isError || screenType === SCREEN_TYPE.REASON_SELECTION) && (
            <DialogTitle>
              <IconButton aria-label="close" onClick={onClose} className={classes.closeIcon}>
                <CloseIcon fontSize="large" />
              </IconButton>
            </DialogTitle>
          )}
          <DialogContent>
            {isLoading && !isError && (
              <div className={classes.centeredContainer}>
                <CircularProgress color="primary" size={50} />
              </div>
            )}
            {isError && (
              <div className={classes.centeredContainer}>
                <ErrorTryAgain noBackground={true} />
              </div>
            )}
            {!isLoading && !isError && screenType === SCREEN_TYPE.REASON_SELECTION && (
              <div className={classes.contentContainer}>
                <div className={classes.heading}>Why are you being kept waiting?</div>
                <div className={classes.note}>
                  Start wait timer if patient pickup is delayed <u>due to client</u>
                </div>
                <ul className={classes.reasonsList}>
                  {reasonsList.map((reason) => {
                    return (
                      <li
                        key={reason.reasonForWaitTimeId}
                        className={classes.reasonItem}
                        onClick={() => {
                          startWaitingTime(reason,null);
                        }}
                      >
                        {reason.name} <ArrowForwardIosIcon />
                      </li>
                    );
                  })}
                </ul>
                <div className={classes.note}>Wait time affects billing, please make your measurements as accurate as possible.</div>
              </div>
            )}

            {!isLoading && !isError && screenType === SCREEN_TYPE.TIMER && (
              <div className={classes.timerContainer}>
                <div className={classes.waitingHeading}>Waiting…</div>
                <div className={classes.waitingReason}>{selectedReason?.name}</div>
                <div className={classes.timer}>{secondsFormat(timerSec)}</div>
                <div onClick={stopTimer} className={classes.stopButton}>
                  Stop Timer
                </div>
                <div onClick={cancelTimer} className={classes.cancelButton}>
                  Cancel
                </div>
              </div>
            )}
          </DialogContent>
        </div>
      </Dialog>
    </ThemeProvider>
  );
};

export default WaitingTimeModal;
